module.exports = __webpack_public_path__ + "static/media/Substitutes-OUT1.1408764d.svg";